import { createTheme as e } from "flowbite-react";
const t = e({
  tabs: {
    base: "flex flex-col gap-2",
    tablist: {
      base: "flex text-center",
      variant: {
        default: "flex-wrap border-b border-gray-200 dark:border-gray-700",
        underline: "flex-wrap -mb-px border-b border-gray-200 dark:border-gray-700",
        pills: "flex-wrap font-medium text-sm text-gray-500 dark:text-gray-400",
        fullWidth: "w-full text-sm font-medium divide-x divide-gray-200 shadow grid grid-flow-col dark:divide-gray-700 dark:text-gray-400 rounded-none"
      },
      tabitem: {
        base: "flex items-center justify-center p-4 rounded-t-lg text-sm font-normal first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500",
        variant: {
          default: {
            base: "font-mono text-dark dark:text-white",
            active: {
              on: "bg-dark dark:bg-white/10 text-dark dark:text-accent backdrop-blur-[15px] shadow-lg",
              off: "text-gray-500 dark:hover:bg-white/10 hover:text-gray-600 dark:text-muted dark:hover:bg-gray-800  dark:hover:text-gray-300  hover:cursor-pointer"
            }
          },
          underline: {
            base: "rounded-t-lg",
            active: {
              on: "text-dark rounded-t-lg border-b-2 border-dark active dark:text-accent dark:border-accent",
              off: "border-b-2 border-transparent text-gray-500 hover:border-accent hover:text-gray-600 dark:text-muted dark:hover:text-accent hover:cursor-pointer"
            }
          },
          pills: {
            base: "font-mono text-dark dark:text-white px-3 py-1.5 rounded-md",
            active: {
              on: "rounded-md text-dark dark:text-accent shadow-lg backdrop-blur-[15px] bg-white dark:bg-white/10",
              off: "rounded-md hover:bg-white/80 dark:hover:bg-dark/10 hover:backdrop-blur-[15px] dark:hover:text-white hover:text-dark hover:cursor-pointer"
            }
          },
          fullWidth: {
            base: "ml-0 first:ml-0 w-full rounded-none flex",
            active: {
              on: "p-4 text-gray-900 bg-gray-100 active dark:bg-gray-700 dark:text-accent rounded-none",
              off: "bg-white hover:text-gray-700 hover:bg-gray-50 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700 rounded-none hover:cursor-pointer"
            }
          }
        },
        icon: "mr-2 h-5 w-5"
      }
    },
    tabitemcontainer: {
      base: "",
      variant: {
        default: "",
        underline: "",
        pills: "",
        fullWidth: ""
      }
    },
    tabpanel: "py-3"
  }
}).tabs;
export {
  t as tabsTheme
};
